<template>
    <div class="container">
        <div>
            <v-card
                class="mx-auto"
                max-width="550"
                color="#8D4E3C"
                dark
            >
                <v-img
                height="550px"
                
                :src="image"
                >
                </v-img>
                
               

                <v-timeline
                    align-top
                    dense
                >
                    <v-timeline-item
                    :key="nombre"
                    color='grey lighten-1'
                    small
                    >
                    <div>
                        <div class="font-weight-normal">
                        <strong>{{ nombre }}</strong>
                        <div>{{ espcialidad }}</div>
                        </div>
                    </div>
                    
                    </v-timeline-item>
                 </v-timeline>
                 <v-timeline
                    align-top
                    dense
                >
                    <v-timeline-item
                    v-if="descripcion != ''"
                    :key="descripcion"
                    color='grey'
                    small
                    >
                    <div>
                        <div class="font-weight-normal">
                        {{ descripcion }}
                        </div>
                        
                    </div>
                    
                    </v-timeline-item>
                 </v-timeline>

            </v-card>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Cards',
    props: {
        nombre: String,      
        espcialidad: String,
        descripcion: String,
        image: String
    },
}
</script>

<style>

</style>